module.exports = __webpack_public_path__ + "img/checkmark-filled.98f3e0be.svg";